import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { gettHeaderByType, settHeaderByType, getMarketCooperation, setMarketCooperationUser, marketCooperationExportData } from '@/api/common'
import {
    getFinanceCommissionList,
    delFinanceCommissionById,
    financeCommissionExportData,
    setFinanceCommissionStatus,
    syncFinanceCommissionToEkuaibao
} from '@/api/financial-center'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import rebateStatistics from "@/views/financial-center/commission/rebate-statistics/index.vue";

@Component({})
export default class Commission extends Vue {
    // 删除
    delOrderId: number = null
    delOrderDialogShow = false
    // 撤回审批
    cancelApproveDialog = false
    cancelApproveId: number = undefined
    // data
    tableHeadPopoverShow = false
    tableHeader: { filds: string; cnFilds: string; isShow: boolean; id: number }[] = []
    tableHead: any[] = []
    tableData = []
    // tableRandom = Math.random()
    tableLoading = false
    page = 1
    limit = 20
    total = 0
    tableHeadFilter = {
        marketCooperationName: '',  //合作伙伴名称
        directorUserIdList: [], //负责人id
        status: '', //返佣状态  允许值: 0-审批中, 1-已通过, 2-未通过, 3-未提交, 4-已撤回
        code: '' ,// 返佣编号
        payStatus :'' , // 打款状态
        payName:''
    }

    tableCheckedData = []
    dialogShow = false
    receiverUser = '' // 修改后的负责人
    tableKey = Math.random()
    loading = false
    exportButtonDisabled = false
    syncVisible = false
    commissionId = ''
    timer = null
    // isReadonly = false
    draggableList = []
    draggableListChange = []

    menuBtn = menuBtn
    // computed
    get userList() {
        return UserModule.userList
    }

    /* created */
    created() {
        this.gettHeaderByType()
    }
    // 跳转统计图表页面
    goToDtatisticsData() {
        const {origin} = window.location
        console.log('origin',origin)
        const src = origin + '/financialCenter/rebateStatistics'
        window.open(src, '_blank')
    }
    // 操作删除
    hendleDelClick(id){
        this.delOrderId = id
        this.delOrderDialogShow = true
    }
    async delOrderDialogConfirm() {
        await delFinanceCommissionById(this.delOrderId)
        this.$message.success('删除成功')
        this.delOrderDialogShow = false
        this.getTableData()
    }
    // 撤回审批
    clickcancelApproveButton(row) {
        this.cancelApproveId = row.id
        this.cancelApproveDialog = true
    }
    async setFinanceCommissionStatus(row: any, action: string) {
        if(action == '0'){
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/commissionEdit?id=' + row.id + '&isUpdatedData=1')
            const time = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(time)
                }
            }, 500)
        }
        this.getTableData()
    }
    async clickCancelApproveDialogConfirmButton() {
        await setFinanceCommissionStatus({ id: this.cancelApproveId, action: '1' })
        this.$message.success('撤销审批成功')
        this.cancelApproveDialog = false
        this.getTableData()
    }

    clickEditButton(row){
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/commissionEdit?id=' + row.id + '&isUpdatedData=0' + '&isShow=' + row.isShow+ '&status=' + row.status)
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
    // 打款信息
    clickEditMoneyInfo(row){
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/commissionMoneyInfo?id=' + row.id + '&isUpdatedData=0' + '&isShow=' + row.isShow+ '&status=' + row.status)
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
    // 列表
    async getTableData() {
        this.loading = true

        const obj = {
            limit: this.limit,  //条数/页
            page: this.page, //页码
            marketCooperationName: this.tableHeadFilter.marketCooperationName,  //合作伙伴名称
            code: this.tableHeadFilter.code,  // 返佣编号
            directorUserIdList: this.tableHeadFilter.directorUserIdList, //负责人id
            status: this.tableHeadFilter.status, //返佣状态  允许值: 0-审批中, 1-已通过, 2-未通过, 3-未提交, 4-已撤回
            payStatus: this.tableHeadFilter.payStatus, //打款状态
            payName: this.tableHeadFilter.payName,
        }
        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        const data: any = await getFinanceCommissionList(obj)
        this.tableData = data.financeCommissionList

        // this.tableData.forEach(item => {
        //     if (item.finance_commission_account) {
        //         item.finance_commission_accountStatus = item.finance_commission_account.status
        //     }
        // })
        this.total = data.allNum
        this.loading = false
        // this.isReadonly = false
        this.tableKey = Math.random()
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).doLayout();
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
    }
    // methods
    async gettHeaderByType() {
        const data: any = await gettHeaderByType(10)
        this.draggableList = data.headerUserList
        this.tableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }
    async draggableEnd() {
        this.tableHeadPopoverShow = false
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({types: 10, headerIds: this.draggableList})
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }
    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false
    }
    changeDate(val: Date[]) {
        const arr: string[] = []
        val.forEach((item: Date) => {
            arr.push(formatDate('yyyy-MM-dd', new Date(item)))
        })
        // this.tableHeadFilter.createdAt = arr.join('/')
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData();
        }, 1000)
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData();
    }
    handleSelectionChange(row: any) {
        this.tableCheckedData = row
    }
    async dialogConfirm() {
        if (!this.receiverUser) {
            this.$message.error('请选择负责人')
            return
        }
        (this.$refs['multipleTable'] as HTMLFormElement).clearSelection();
    }
    openDtatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/CooperationStatisticsData')
    }
    openGiveStudent() {
        if (menuBtn(31)) {
            window.open(window.location.origin + this.$route.matched[0].path + '/GiveStudent')
        }
    }

    // 新增
    openNewPartner() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/commissionAdd', '_blank')
        const timer = setInterval(() => {
            if(win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    // 点击表格进入详情
    clickRow(row: any, cloumn: any) {
        if(menuBtn(99)){
            const win  =window.open(window.location.origin + this.$route.matched[0].path + '/commissionInfo?id=' + row.id + '&status=' + row.status + '&isUpdatedData=0', '_blank')
            const timer = setInterval(() => {
                if(win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        }else {
            this.$message.error('您没有查看权限');
        }
    }

    // 导出
    async exportExcel() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const obj = {
            page: this.page,
            limit: this.limit,
            marketCooperationName: this.tableHeadFilter.marketCooperationName,  //合作伙伴名称
            code: this.tableHeadFilter.code,  // 返佣编号
            directorUserIdList: this.tableHeadFilter.directorUserIdList, //负责人id
            status: this.tableHeadFilter.status, //返佣状态  允许值: 0-审批中, 1-已通过, 2-未通过, 3-未提交, 4-已撤回
            payStatus: this.tableHeadFilter.payStatus, //打款状态
            payName: this.tableHeadFilter.payName,
        }
        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        financeCommissionExportData(obj).finally(() => {
            this.exportButtonDisabled = false
        })
    }

    syncData(row) {
        this.commissionId = row.id
        this.syncVisible = true
    }

    async syncDialogConfirm() {
        this.syncVisible = false
        await syncFinanceCommissionToEkuaibao({id: this.commissionId})
        this.$message.success('同步单据成功')
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }
    watch: {
        '$route': 'getTableData';
    }
}
